// icp备案网址
export const BEIAN_URL = 'https://beian.miit.gov.cn/'